import type { FC } from 'react';
import { UploadCreativesX } from 'features/cabinet';
import { CabinetTitlePage } from 'components/layout';

const UploadCreativesPage: FC = () => (
  <>
    <CabinetTitlePage title={'Ads replacement'} />
    <UploadCreativesX />
  </>
);

export default UploadCreativesPage;
